import React from "react";
import "./Empresa.css";

import Navbar from "../../components/Navbar/Navbar";
import EmpresaHero from "../../components/Empresa/HeroEmpresa/HeroEmpresa";
import QuienesSomos from "../../components/Empresa/QuienesSomos/QuienesSomos";
import NuestraEsencia from "../../components/Empresa/NuestraEsencia/NuestraEsencia";
import PilaresEmpresa from "../../components/Empresa/PilaresEmpresa/PilaresEmpresa";
import VisionFuturo from "../../components/Empresa/VisionFuturo/VisionFuturo";
import EmpresaCierre from "../../components/Empresa/EmpresaCierre/EmpresaCierre";
import Footer from "../../components/Footer/Footer";

function Empresa() {
  return (
      <>
      <Navbar />
      <main className="empresa-page">
        <EmpresaHero />
        <QuienesSomos />
        <NuestraEsencia>
          <PilaresEmpresa />
        </NuestraEsencia>
        <VisionFuturo />
        <EmpresaCierre />
      </main>

    <Footer />

      </>
  );
}

export default Empresa;
